import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Components
import { TextInput, Button } from "src/Components";
// Types
import { ISyntheticConfig, SyntheticApiTab } from "src/Interfaces/Synthetic";
// Requests
import {
  getPairPositionConfig,
  setPairPositionConfig,
} from "src/Requests/synthetic";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  apiTab?: SyntheticApiTab;
  onClose: () => void;
}
const SettingModal: React.FC<IProps> = (props) => {
  // local store
  const [config, setConfig] = React.useState({} as ISyntheticConfig);

  React.useEffect(() => {
    getPairPositionConfig(props.apiTab)
      .then((res) => {
        setConfig(res);
      })
      .catch(packetErrorHandler);
  }, [props.apiTab]);
  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const setConfigHandler = () => {
    setPairPositionConfig(config, props.apiTab)
      .then((resp) => {
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => {
        props.onClose();
      });
  };

  return (
    <div className="w-full flex flex-col justify-center items-center gap-3">
      <div className="flex w-full items-center">
        <TextInput
          label="٪ بازده درآمد ثابت"
          name="fixedIncomeProfit"
          onChange={changeHandler}
          value={config?.fixedIncomeProfit?.toString() || ""}
          kind="percent"
          extraLabel
        />
      </div>

      <div className="w-52 mt-2">
        <Button onClick={setConfigHandler} text="ثبت" variant="contained" />
      </div>
    </div>
  );
};

export default SettingModal;
